import { createContext } from 'react'

const IsResponsiveEnabledContext = createContext(true)

export default IsResponsiveEnabledContext



// WEBPACK FOOTER //
// ./src/Shared/IsResponsiveEnabledContext.js